import { GetCustomSurfaceTemplateQueryParams } from '../../models/custom-surface-template.model';

const customSurfaceTemplateKeys = {
    all: (params: GetCustomSurfaceTemplateQueryParams) => [
        'surface-templates',
        params,
    ],
    detail: (id: string) => ['surface-templates', id],
};

export default customSurfaceTemplateKeys;
